export default "__VITE_ASSET__DRvEelCr__"